<template>
    <div>
        <ejs-grid ref="systemCounterGrid" :dataSource="dataSourceOfSystemCounter" class="h100-60 h-scroll" :allowPaging="false" height='calc(100vh - 280px)'>
            <e-columns>
                <e-column field="counterName" :headerText="$t('Pm.counterName')" textAlign="center"  width="33%"  clipMode="EllipsisWithTooltip" :formatter="counterNameFormatter"></e-column>
                <e-column field="counterCode" :headerText="$t('Pm.counterCode')" textAlign="center"  width="33%"  clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="unit" :headerText="$t('Pm.counterUnit')" textAlign="center"  width="33%"  clipMode="EllipsisWithTooltip"></e-column>
            </e-columns>
        </ejs-grid>
        <ejs-pager ref='systemCounterPager' @click='getSystemCounterList()' :currentPage='pageSettings.currentPage' :pageCount='pageSettings.pageCount' :pageSize='pageSettings.pageSize' :totalRecordsCount='pageSettings.totalRecordsCount'></ejs-pager>
    </div>
</template>

<script>

    export default {
        name: 'SystemCounterList',

        components: {
        },

        props: [
            'gnbCounterTreeClickInfo'
        ],

        data() {
            return {
                dataSourceOfSystemCounter: [],
                pageSettings: {
                    currentPage: 1,
                    pageSize: 18,
                    totalRecordsCount: 0,
                    pageCount: 10
                },
                spaceCode: null,
                paramTypeCode: null,
                counterSearchName: null
            };
        },

        methods: {
            counterNameFormatter(column,data){
                return (this._i18n.locale === 'zh') ? data['counterNameCH'] : data['counterNameEN'];
            },
            getSystemCounterList(){
                const language = localStorage.getItem('locale');
                this.pageSettings.currentPage = this.$refs.systemCounterPager.ej2Instances.currentPage;
                this.$loading.showLoadding(this.$t('System.loading'));
                this.$axios.post('/lte/ems/pm/gnb/counter/getSystemCounterList.html', {
                    paramTypeCode: this.paramTypeCode,
                    spaceCode: this.spaceCode,
                    counterNameCH: language == 'zh' ? this.counterName : null,
                    counterNameEN: language == 'zh' ? null : this.counterName,
                    page: {
                        pageNo: this.pageSettings.currentPage,
                        pageSize: this.pageSettings.pageSize
                    }
                }).then((response) => {
                    const result = response.data.resultVal;
                    this.pageSettings.totalRecordsCount = result.totalCount;
                    this.pageSettings.currentPage = result.pageNo;
                    this.dataSourceOfSystemCounter = result.result;
                    this.$loading.hideLoadding();
                });
            }
        },
        watch: {
            gnbCounterTreeClickInfo(treeClickInfo){
                this.pageSettings.currentPage = 1;
                this.$refs.systemCounterPager.ej2Instances.currentPage = 1;
                const clickId = treeClickInfo.id;
                if(clickId == 'root'){
                    this.spaceCode = null;
                    this.paramTypeCode =null;
                }  else if(clickId.split('_')[1] == undefined) {
                    this.spaceCode = null;
                    this.paramTypeCode = clickId.split('_')[0]
                } else {
                    this.spaceCode = clickId.split('_')[0];
                    this.paramTypeCode = clickId.split('_')[1]
                }
                this.getSystemCounterList();
            }
        },

        mounted() {
            this.getSystemCounterList();
        }
    };
</script>

<style scoped>
</style>
